import axios from 'axios';
axios.defaults.timeout = 20000;
const api = axios.create({
    baseURL: 'https://upbusca.com',
    headers: {'Authorization': 'Bearer '+window.localStorage.getItem('token')}
});

export default api;
